export default __webpack_public_path__ + "static/media/service4.1c7430c2.jpg";